import React from 'react'

export const StoreIcon = ({ title, height, width, color, ...rest  }) => {
    const useColor = color ? color : '#3C3C3B'
    const useHeight = height ? height : "24px";
    const useWidth = width ? width : "24px";
    return (
      <svg
        width={useWidth}
        height={useHeight}
        viewBox="0 0 24 24"
        fill="none"
      >
        {title && <title>{title}</title>}
        <rect width="24" height="24" fill="none" stroke="none"/>
        <g>
          <path d="M6.95 4.4C7.04315 4.2758 7.16393 4.175 7.30279 4.10557C7.44164 4.03615 7.59475 4 7.75 4H16.25C16.4052 4 16.5584 4.03615 16.6972 4.10557C16.8361 4.175 16.9569 4.2758 17.05 4.4L19.9 8.2C19.9649 8.28655 20 8.39181 20 8.5V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V8.5C4 8.39181 4.03509 8.28655 4.1 8.2L6.95 4.4ZM11.5 5H7.75L5.5 8H11.5V5ZM12.5 5V8H18.5L16.25 5H12.5ZM19 9H5V19H19V9Z" fill={useColor} />
          <path d="M11.6464 16.3536C11.8417 16.5488 12.1583 16.5488 12.3536 16.3536L15.5355 13.1716C15.7308 12.9763 15.7308 12.6597 15.5355 12.4645C15.3403 12.2692 15.0237 12.2692 14.8284 12.4645L12 15.2929L9.17157 12.4645C8.97631 12.2692 8.65973 12.2692 8.46447 12.4645C8.2692 12.6597 8.2692 12.9763 8.46447 13.1716L11.6464 16.3536ZM11.5 10V16H12.5V10H11.5Z" fill={useColor} />
        </g>
      </svg>
    );
  };
  
